var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "check-badge-svgrepo-com_3_",
    "data-name": "check-badge-svgrepo-com (3)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M10.632,3.887a3.452,3.452,0,0,1,5.618,0l.219.307a1.151,1.151,0,0,0,1.063.475l.977-.109a3.452,3.452,0,0,1,3.812,3.812l-.109.977a1.151,1.151,0,0,0,.475,1.063l.307.219a3.452,3.452,0,0,1,0,5.618l-.307.219a1.151,1.151,0,0,0-.475,1.063l.109.977a3.452,3.452,0,0,1-3.812,3.812l-.977-.109a1.151,1.151,0,0,0-1.063.475L16.25,23a3.452,3.452,0,0,1-5.618,0l-.219-.307a1.151,1.151,0,0,0-1.063-.475l-.977.109A3.452,3.452,0,0,1,4.56,18.51l.109-.977a1.151,1.151,0,0,0-.475-1.063l-.307-.219a3.452,3.452,0,0,1,0-5.618l.307-.219a1.151,1.151,0,0,0,.475-1.063L4.56,8.372A3.452,3.452,0,0,1,8.372,4.56l.977.109a1.151,1.151,0,0,0,1.063-.475Zm7.075,6.439a1.151,1.151,0,0,1,0,1.627l-4.395,4.395a1.445,1.445,0,0,1-2.044,0L9.175,14.255A1.151,1.151,0,1,1,10.8,12.627l1.488,1.488,3.789-3.789A1.151,1.151,0,0,1,17.707,10.326Z",
    transform: "translate(-2.441 -2.441)",
    fill: "#37e0eb",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.c4ac3863ecea3ab520583f000dc311d3.svg";
export { ForwardRef as ReactComponent };